/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

// stall
export const getQueueStallID = stall => (stall && stall.id ? stall.id : null);
export const getQueueStallName = stall =>
  stall && stall.name ? stall.name : null;
export const getQueueStallItems = stall =>
  stall && stall.items ? stall.items : null;

// item
export const getQueueStallItemID = queue =>
  queue && queue.id ? queue.id : null;
export const getQueueStallItemStatusCode = queue =>
  queue && queue.status && queue.status.code ? queue.status.code : null;
export const getQueueStallItemStatusName = queue =>
  queue && queue.status && queue.status.name ? queue.status.name : null;
export const getQueueStallItemReferenceNumber = queue =>
  queue && queue.reference_numer ? queue.reference_numer : null;
export const getQueueStallItemQueueNumber = queue =>
  queue && queue.queue_number ? queue.queue_number : null;
export const getQueueStallItemTitle = queue =>
  queue && queue.title ? queue.title : null;
export const getQueueStallItemDescription = queue =>
  queue && queue.description ? queue.description : null;
export const getQueueStallItemImageLarge = queue =>
  queue && queue.image && queue.image.large && queue.image.large.src
    ? queue.image.large.src
    : null;
export const getQueueStallItemAddOnsItem = queue =>
  queue && queue.addons && queue.addons.items ? queue.addons.items : null;
export const getQueueStallItemVariantsItem = queue =>
  queue && queue.variants && queue.variants.items ? queue.variants.items : null;
export const getQueueStallItemAttributeIsDelivery = queue =>
  queue && queue.attribute && queue.attribute.is_delivery
    ? queue.attribute.is_delivery
    : false;
export const getQueueStallItemAttributeIsTakeAway = queue =>
  queue && queue.attribute && queue.attribute.is_take_away
    ? queue.attribute.is_take_away
    : false;
export const getQueueStallITemEstimateWaitTime = queue =>
  queue && queue.estimate_wait_time ? queue.estimate_wait_time : "";



// WEBPACK FOOTER //
// ./src/selectors/queue.js